import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { KnowledgeManagementEvents } from 'lib-knowledge-types';
import { authManager } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';
import { ampli } from 'lib-shared-tracking';
import { Suspense, useMemo } from 'react';

import { useNotifications } from 'hooks/useNotifications';

import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading';
import { RemoteKnowledgeManagementRoutes } from './components/remotes';

export const KnowledgeManagementRoutes = (): JSX.Element => {
  const notify = useNotifications();

  const onHandlers = useMemo(() => {
    const handlers: KnowledgeManagementEvents = {
      'article:created': (payload) => ampli.knowledgeArticleCreated(payload),
      'article:updated': (payload) => ampli.knowledgeArticleUpdated(payload),
      'article:changes-discarded': (payload) =>
        ampli.knowledgeArticleChangesDiscarded(payload),
      'article:reordered': (payload) =>
        ampli.knowledgeArticleReordered(payload),
      'article:published': (payload) =>
        ampli.knowledgeArticlePublished(payload),
      'article:unpublished': (payload) =>
        ampli.knowledgeArticleUnpublished(payload),
      'article:archived': (payload) => ampli.knowledgeArticleArchived(payload),
      'article:destroyed': (payload) =>
        ampli.knowledgeArticleDestroyed(payload),
      'article:viewed': (payload) => ampli.knowledgeArticleViewed(payload),
      'article:tag-added': (payload) => ampli.knowledgeArticleTagAdded(payload),
      'article:tag-removed': (payload) =>
        ampli.knowledgeArticleTagRemoved(payload),
      'article:moved': (payload) => ampli.knowledgeArticleMoved(payload),
      'articles:searched-by-terms': (payload) =>
        ampli.knowledgeArticlesSearchByTermSubmitted(payload),
      'category:created': (payload) => ampli.knowledgeCategoryCreated(payload),
      'category:updated': (payload) => ampli.knowledgeCategoryUpdated(payload),
      'category:reordered': (payload) =>
        ampli.knowledgeCategoryReordered(payload),
      'category:destroyed': (payload) =>
        ampli.knowledgeCategoryDestroyed(payload),
      'collection:created': (payload) =>
        ampli.knowledgeCollectionCreated(payload),
      'collection:viewed': (payload) =>
        ampli.knowledgeCollectionViewed(payload),
      'collection:updated': (payload) =>
        ampli.knowledgeCollectionUpdated(payload),
      'collection:destroyed': (payload) =>
        ampli.knowledgeCollectionDestroyed(payload),
      'internalKb:dashboard-viewed': (payload) =>
        ampli.knowledgeInternalKbDashboardViewed(payload),
      'internalKb:search-result-clicked': (payload) =>
        ampli.knowledgeInternalKbSearchResultClicked(payload),
      'help-center:created': (payload) =>
        ampli.knowledgeHelpCenterCreated(payload),
      'help-center:updated': (payload) =>
        ampli.knowledgeHelpCenterUpdated(payload),
      'help-center:destroyed': (payload) =>
        ampli.knowledgeHelpCenterDeleted(payload),
    } as KnowledgeManagementEvents;
    return handlers;
  }, []);

  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <Suspense fallback={<KnowledgeLoading />}>
        <RemoteKnowledgeManagementRoutes
          getLock={async () => await authManager.getAuthData()}
          on={onHandlers}
          notify={notify}
          environment={config.environment}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
